import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../guards/authguard/auth-guard';
import { featureActivatedGuard } from '../../guards/feature-activated/feature-activated.guard';
import { AmazonFinanceConfigurationComponent } from './components/amazon-finance-configuration/amazon-finance-configuration.component';
import { AmazonFinanceConsoleComponent } from './components/amazon-finance-console/amazon-finance-console.component';
import { AmazonFinanceReportsComponent } from './components/amazon-finance-reports/amazon-finance-reports.component';
import { AmazonFinanceDeliveryCountryComponent } from './components/amazon-finance-delivery-country/amazon-finance-delivery-country.component';
import { AmazonFinanceJobsComponent } from './components/amazon-finance-jobs/amazon-finance-jobs.component';
import { AmazonFinanceMappingsComponent } from './components/amazon-finance-mappings/amazon-finance-mappings.component';
import { AmazonFinanceTransactionsComponent } from './components/amazon-finance-transactions/amazon-finance-transactions.component';
import { GungMainMenuService } from '../../services/gung-main-menu/gung-main-menu.service';
import { AmazonFinanceMainMenuService } from './services/amazon-finance-main-menu.service';
import { AmazonFinanceTranslationsService } from './services/amazon-finance-translations.service';
import { AMAZON_FINANCE_FEATURE_ID, AMAZON_FINANCE_MINIMUM_GUNG_BASE_VERSION } from './services/amazon-finance-feature';

export const AMAZON_FINANCE_ROUTES: Routes = [
  {
    path: 'admin/amazon-finance',
    canActivate: [AuthGuard, featureActivatedGuard],
    component: AmazonFinanceConsoleComponent,
    data: {
      gungTitle: '<GUNGTRANSLATE>AMAZON_FINANCE_TITLE</GUNGTRANSLATE>',
      featureId: AMAZON_FINANCE_FEATURE_ID,
      minimumGungBaseVersion: AMAZON_FINANCE_MINIMUM_GUNG_BASE_VERSION,
      failIfNoBaseVersion: true
    }
  }
];

export function placeAmazonFinanceRoutesBeforeWildcard(routes: Routes): Routes {
  const amazonPaths = new Set(AMAZON_FINANCE_ROUTES.map(route => route.path));
  const reorderedRoutes = routes.filter(route => !amazonPaths.has(route.path));
  const wildcardIndex = reorderedRoutes.findIndex(route => route.path === '**');

  reorderedRoutes.splice(wildcardIndex < 0 ? reorderedRoutes.length : wildcardIndex, 0, ...AMAZON_FINANCE_ROUTES);
  return reorderedRoutes;
}

@NgModule({
  declarations: [
    AmazonFinanceConfigurationComponent,
    AmazonFinanceConsoleComponent,
    AmazonFinanceDeliveryCountryComponent,
    AmazonFinanceJobsComponent,
    AmazonFinanceReportsComponent,
    AmazonFinanceMappingsComponent,
    AmazonFinanceTransactionsComponent
  ],
  imports: [CommonModule, FormsModule, TranslateModule, RouterModule.forChild(AMAZON_FINANCE_ROUTES)],
  exports: [AmazonFinanceConsoleComponent],
  providers: [
    { provide: GungMainMenuService, useClass: AmazonFinanceMainMenuService },
    AmazonFinanceTranslationsService
  ]
})
export class AmazonFinanceModule {
  constructor(
    router: Router,
    translations: AmazonFinanceTranslationsService
  ) {
    translations.register();
    router.resetConfig(placeAmazonFinanceRoutesBeforeWildcard(router.config));
  }
}
